export const graphqlUnifiedProductQuery = `
query ProductDetail($productUri: String!) {
  product(by: { uri: $productUri }) {
    attributes {
      allAttributes
    }
  }
}
`;
